import React from "react";
import Layout from "../components/Layout";
import { Link } from "react-router-dom";

export default function Events() {
  return (
    <Layout>
      <div id="main-content">
        <div 
            className="page-title-wrapper" 
            data-stellar-background-ratio="0.5"
            style={{height: "500px", backgroundPosition: "center", backgroundImage: 'url(images/event-bg.jpg)'}}
        >
          <div className="content container">
            <h1 className="heading_primary">Evenements</h1>
          </div>
        </div>

        <div className="site-content container">
            <div className="events-content">
                <div className="sc-events list-style">
                    <div className="tab-content" id="nav-tabContent">
                        <div className="tab-pane fade show active" id="happening" role="tabpanel">
                            <div className="event">
                                <div className="row tm-flex">
                                    <div className="col-lg-2 col-md-2">
                                        <div className="time-from">
                                            <span className="date">25</span>
                                            <span className="month">Septembre</span>
                                        </div>
                                    </div>
                                <div className="col-lg-6 col-md-5">
                                    <div className="event-content">
                                        <h3 className="title"><Link to="#">Festival de grillades Barbecue</Link></h3>
                                        <div className="meta">
                                            <span className="time"> <i className="fa fa-clock-o"></i> 10:00 - 22:00</span>
                                            <span className="location"> <i className="fa fa-map-marker"></i>Songon Park</span>
                                        </div>
                                        <div className="event-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mattis eleifend lorem nec ultricies. </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-5">
                                    <div className="thumbnail">
                                        <Link to="#"><img src={require('../assets/grillades.jpg')} alt=""/></Link>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div className="event">
                                <div className="row tm-flex">
                                    <div className="col-lg-2 col-md-2">
                                        <div className="time-from">
                                            <span className="date">05</span>
                                            <span className="month">Octobre</span>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-5">
                                        <div className="event-content">
                                            <h3 className="title"><Link to="#">Le carnaval de Jacquevile</Link></h3>
                                            <div className="meta">
                                                <span className="time"> <i className="fa fa-clock-o"></i> 8:00 - 17:00 am</span>
                                                <span className="location"> <i className="fa fa-map-marker"></i>Songon Park</span>
                                            </div>
                                            <div className="event-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mattis eleifend lorem nec ultricies. </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-5">
                                        <div className="thumbnail">
                                            <Link to="#"><img src={require('../assets/carnaval.jpg')} alt=""/></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="event">
                                <div className="row tm-flex">
                                    <div className="col-lg-2 col-md-2">
                                        <div className="time-from">
                                            <span className="date">20</span>
                                            <span className="month">Novembre</span>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-5">
                                        <div className="event-content">
                                            <h3 className="title"><Link to="#"> Festival des couleurs</Link></h3>
                                            <div className="meta">
                                                <span className="time"> <i className="fa fa-clock-o"></i> 08:00 - 15:00</span>
                                                <span className="location"> <i className="fa fa-map-marker"></i>Songon Park</span>
                                            </div>
                                            <div className="event-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mattis eleifend lorem nec ultricies. </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-5">
                                        <div className="thumbnail">
                                            <Link to="#"><img src={require('../assets/couleurfestival.jpg')} alt=""/></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
      
      </div>
    </Layout>
  );
}
